

































































































































import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, StoreHelper } from '../../core/mixins';
import { Component, Mixins, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import Input  from '../../core/components/Input.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import LoadingIndicator from '../../core/components/LoadingIndicator.vue';
import multiselect from 'vue-multiselect';
import MultipleSelect from '../../core/components/MultipleSelect.vue';
import { BackendDynamicFieldsResponse } from '../../../features/alarms/api/api-responses';
import { isNullOrEmpty, isNumber } from '../../../features/core/utils';
import { DynamicFieldsResponse, dynamicFieldsTypes, dynamicFieldsValueTypes, DynamicFieldType, DynamicFieldValueType } from '../../../features/custom_frontend/models';
import { fieldIsMultiCombobox, fieldIsMultiSelect } from '../../../features/core/utils/logic_backend_fields';
import { BackendDynamicField } from '../../../features/alarms/api/types';
import { CustomFrontendServices } from '../../../features/custom_frontend/api/CustomFrontendServices';
@Component({
    components: { 
      Input, 
      SectionTitle,
      LoadingIndicator,
      InfoIcon,
      multiselect,
      AlertBox,
      MultipleSelect
   }
})
export default class BackendDynamicFields extends Mixins(
   RootStoreHelper, 
   NotificationStoreHelper,
   CompanyStoreHelper
) {
   @Prop({default: false}) gettingFields: boolean;
   @Prop({default: {}}) fieldsOptions: BackendDynamicField;
   @Prop({default: 'Cargando campos...'}) loadingText: boolean;
   @Prop() getDefaultFields: Function;


   emptyFieldsMsg: string = '';
   fieldsTypes: DynamicFieldType = dynamicFieldsTypes;
   fieldsValues: DynamicFieldValueType = dynamicFieldsValueTypes;

 

   mounted(){
      CustomFrontendServices.getAllDynamicFields()
         .then((response: DynamicFieldsResponse) => {
            this.fieldsTypes = response.fields_types;
            this.fieldsValues = response.fields_values;
            this.getDefaultFields();
         }
      ).catch((error) => {
         this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: 'Error al obtener custom_frontend fields'
         })
      })
   }

   get areEmptyFields(){
      //devuelvo si hay campos vacios
      let areEmptyFields = false;
      this.emptyFieldsMsg = '<b>Campos sin completar:</b>'
      Object.keys(this.fieldsOptions).forEach((key) => {
         if(this.fieldsOptions[key]['required'] == false){
            return;
         }

         if(fieldIsMultiCombobox(this.fieldsOptions[key])){
            //validacion para combobox multiple
            if(this.fieldsOptions[key]['preselected_options'].length == 0){
               this.emptyFieldsMsg += ` ${this.fieldsOptions[key]['label']},`
               areEmptyFields = true;
            }
         }else{
            if(isNullOrEmpty(this.fieldsOptions[key]['current_value'])){
               this.emptyFieldsMsg += ` ${this.fieldsOptions[key]['label']},`
               areEmptyFields = true;
            }
         }
         
      })
      this.fieldAreEmpty(areEmptyFields)
      return areEmptyFields;
   }

    handleAddMultiCombobox(itemToAdd, fieldName) {
      this.fieldsOptions[fieldName]['preselected_options'].push(itemToAdd);
    }

    handleRemoveMultiCombobox(itemToRemove, fieldName) {
      this.fieldsOptions[fieldName]['preselected_options'] = this.fieldsOptions[fieldName]['preselected_options'].filter(item => item.id !== itemToRemove.id);
    }

   @Emit()
   fieldAreEmpty(value: boolean){
      return value;
   }

   getCurrentValueParsed(field: BackendDynamicField){
      //devuelvo el valor actual para cada campo
      let currentValue = field['current_value'];
      let previousValue = currentValue;

      if(fieldIsMultiSelect(field) && currentValue !== null){
         //si es un multiselect devuelvo el id
         currentValue = currentValue['id'];
      }

      if(isNumber(currentValue)){
         currentValue = Number(currentValue)
      }

      if(fieldIsMultiCombobox(field) && field['preselected_options'].length > 0){
         currentValue = field['preselected_options'].map((item) => {
            return Number(item['id'])
         })
      }
      return currentValue;
   }

   getCurrentFields(): BackendDynamicField{
      //devuelvo los campos dinamicos con sus valores actuales
      //para enviar al backend
      let alarmFieldsData = {} as  BackendDynamicField;
      Object.keys(this.fieldsOptions).forEach((key) => {
         //agrego los valores actuales de cada campo
         alarmFieldsData[key] = this.getCurrentValueParsed(this.fieldsOptions[key])
      })
      return alarmFieldsData;
   }
    
 
}
